// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JWqy","colMin":"styles_colMin__2S8i1"};